module.exports = __webpack_public_path__ + "logo.png?85de3bb2b360f89928d5157ecb1f8725";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 530
// module chunks = 0